import React from 'react';
import classname from 'classnames';
import styled from 'styled-components';

const RadioStyled = styled.input`
    margin: 10px;
`;

const RadioLabel = styled.label`
    text-align: center;
`;


export class RadioButton extends React.PureComponent {
    render() {
        return (
            <div>
                <RadioStyled
                    checked={this.props.selected}
                    type='radio'
                    name={this.props.name}
                    value={this.props.value}
                    id={this.props.id}
                    style={this.props.style}
                    className={this.props.className}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
                />
                <RadioLabel className={this.props.labelClass}>
                    {this.props.label}
                </RadioLabel>
            </div>
        );
    }
}